import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import InfoBar from '../components/InfoBar';
import LunchMenu from '../components/LunchMenu';
import AboutUs from '../components/AboutUs';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FAF6F0]">
      <Header />
      <main>
        <Hero />
        <InfoBar />
        <LunchMenu />
        <AboutUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
